import React from "react"
import { BADGE_TEXT_SOURCE_LABELS, BadgeElement, BadgeElementType } from "sharedTypes/badge"
import Icon from "components/elements/Icon"
import {
  TypeIcon,
  RectangleEllipsisIcon,
  RectangleIcon as RectangleHorizontalIcon,
  CircleIcon,
} from "../../Icons"

export const getElementIcon = (type: BadgeElementType): React.ReactNode => {
  switch (type) {
    case BadgeElementType.TEXT:
      return <TypeIcon width={20} height={20} strokeWidth={1.5} />
    case BadgeElementType.FIELD:
      return <RectangleEllipsisIcon width={20} height={20} strokeWidth={1.5} />
    case BadgeElementType.IMAGE:
      return <Icon icon="email-block-image" size={5} />
    case BadgeElementType.LINE:
      return <Icon icon="email-block-divider" size={5} />
    case BadgeElementType.RECTANGLE:
      return <RectangleHorizontalIcon width={20} height={20} strokeWidth={1.5} />
    case BadgeElementType.OVAL:
      return <CircleIcon width={20} height={20} strokeWidth={1.5} />
    case BadgeElementType.QR_CODE:
      return <Icon icon="email-block-qr-code" size={5} />
    default:
      return <TypeIcon width={20} height={20} strokeWidth={1.5} />
  }
}

export const getElementDisplayName = (element: BadgeElement) => {
  switch (element.type) {
    case BadgeElementType.TEXT: {
      const textData = element.data // TypeScript narrows this automatically

      // For Text elements, show the actual text content (truncated)
      if (textData?.text) {
        const text = textData.text.trim()

        return text.length > 20 ? `${text.substring(0, 20)}...` : text
      }

      return "Text" // Empty text element
    }
    case BadgeElementType.FIELD: {
      const fieldData = element.data // TypeScript narrows this automatically

      // For field elements, always show the user-friendly label for the data source
      if (fieldData?.source && BADGE_TEXT_SOURCE_LABELS[fieldData.source]) {
        return `${BADGE_TEXT_SOURCE_LABELS[fieldData.source]}`
      }

      return "Field"
    }
    case BadgeElementType.IMAGE: {
      // BadgeImageData doesn't have alt property, just use "Image"
      return "Image"
    }
    case BadgeElementType.LINE:
      return "Line"
    case BadgeElementType.RECTANGLE:
      return "Rectangle"
    case BadgeElementType.OVAL:
      return "Oval"
    case BadgeElementType.QR_CODE:
      return "QR Code"
    default:
      return "Element"
  }
}
